<template>
  <!-- 企业历程 -->
  <div class="course">
    <div style="text-align: right; ">
      <el-button size="small" @click="add" class="rightbutton" type="success" >添加</el-button>
      <el-button size="small" @click="save" class="rightbutton" type="primary" >保存数据</el-button>
    </div>
    <div v-for="(item,i) in tableData" :key="i" class="item">
      <div class="row">
        <label>事件年月</label>
        <el-date-picker style="width:15rem" value-format="yyyy-MM-dd HH:mm:ss" v-model="item.eventTime"  format="yyyy年MM月" type="month" placeholder="选择年月"></el-date-picker>
        <el-button size="small" @click="del(item,i)" class="rightbutton" type="danger">移除</el-button>    
      </div>
      <div class="row">
        <label>事件内容</label>
        <el-input  maxlength="20" show-word-limit style="width:18.3rem" placeholder="请输入内容(20字内)" v-model="item.content" clearable></el-input>
      </div>
      <div class="row">
        <label style="height:120px;line-height: 120px;" >背景图片</label>
        <el-upload class="avatar-uploader" :http-request="(e)=>{uploadfile(e,i)}" action="" :show-file-list="false">
          <img v-if="item.backImg" :src="item.backImg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

        <!-- <img style="width:320px;height:120px;" src="@/assets/images/10601172351.jpg"> -->
      </div>

    </div>


  </div>
</template>

<script>
import api from '@/apis/recommend/course'
import upapi from '@/apis/upload'
export default {
  data() {
    return {
      tableData: [
        {
          eventTime:'',
          content:'',
          backImg:'',
        },

        
      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist(){
      api.list({
        params:{
          limit:100,
          page:1
        }
      }).then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.tableData = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })    
    },
    add(){
      this.tableData.unshift(
        {
          eventTime:'',
          content:'',
          backImg:'',
        }
      )
    },
    del(item,i){
      this.$confirm(`确定删除数据？`).then(() => {

        if (item.id) {
          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
              this.tableData.splice(i,1)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.tableData.splice(i,1)
        }

      })
    },

    save() {
      // console.log(this.tableData);
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.getlist()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val,i) {
      console.log(val,i);

      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.tableData[i].backImg = res.data
          this.$message.success(res.message)
          // this.save()
        } else {
          this.$message.error(res.message)
        }
      })
    },



  },
}
</script>

<style lang="less">
.course { padding-top: 15px;
  .avatar-uploader{
    display: inline-block;
  }
  .avatar,
  .avatar-uploader-icon {
    width: 18.3rem !important;
    height: 11rem !important;
    line-height: 11rem !important;
    text-align: center; border: #555e86 dashed 1px; font-size: 2rem;
  }

  .item {
    width: 40%; border: #555e86 dashed 1px; display: inline-block;
    margin-right: 2rem;margin-top: 20px; padding: 15px 30px; vertical-align: top;
    .row {
      position: relative; margin-bottom: 1rem;
      label{ display: inline-block; width: 6rem; text-align: right; padding-right: 15px;vertical-align:top;
      // background: #3570ff; color: #fff; 
      font-size: .8rem; height: 1.8rem; line-height: 1.8rem;}
      .el-button{ margin-left: 10px;}
    }
  }
}
</style>